module.exports = __webpack_public_path__ + "img/BlackMCCard.d99d68db.png";